import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthorizedLpSelected } from '../../actions/lp';
import { GET_AUTHORIZED_LP_SELECTED_REQUEST } from '../../actions/lp/actionTypes';
import { getAuthorizedLpSelectedSelector } from '../../actions/lp/selectors';

export function useLpSelected() {
  const dispatch = useDispatch();
  const lpSelected = useSelector(getAuthorizedLpSelectedSelector);

  useEffect(() => {
    dispatch(
      getAuthorizedLpSelected.request({}, GET_AUTHORIZED_LP_SELECTED_REQUEST)
    ); // To fetch Lp that is already selected
  }, [dispatch]);

  return lpSelected;
}
